import { withPermissionGuard } from '@libs/permission'
import { CampaignListPage } from './CampaignListPage'
import { withCampaignListPage } from './withCampaignListPage'

const Connected = withPermissionGuard(
  withCampaignListPage(CampaignListPage),
  'promotionCampaign',
  'view'
)

export { Connected as CampaignListPage }
